<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" style="margin-top: 15px;">
                <div class="yx-flex-h-start">
                    <div>
                        设备型号：
                        <el-select v-model="searchVal.devModelId" placeholder="设备型号" size="mini" clearable filterable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in devModels"
                                    :key="item.id"
                                    :label="item.model"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        仓储状态：
                        <el-select v-model="searchVal.devStrStatId" placeholder="仓储状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevStorageStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        分配状态：
                        <el-select v-model="searchVal.devFpStat" placeholder="分配状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevFpStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        绑定状态：
                        <el-select v-model="searchVal.devBindStat" placeholder="绑定状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevBindStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div  class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>
                        激活状态：
                        <el-select v-model="searchVal.devActStatId" placeholder="激活状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevActiveStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        预设费率：
                        <el-select v-model="searchVal.preSetRate" placeholder="预设费率" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.QrPreSetRateEnum"
                                    :key="item.id"
                                    :label="item.desc"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-s-shop" @click="TerBind" :disabled="disableBtn" style="font-size: 12px;">绑定商户</el-button>
                <!--
                <el-button type="success" icon="el-icon-setting" @click="TerSetRate" :disabled="disableBtn" style="margin-left: 10px">个性化费率</el-button>
                -->
                <el-dropdown trigger="click" @command="TerSetRate">
                    <el-button type="success" icon="el-icon-setting" @click="" :disabled="disableBtn" style="margin-left: 10px;">
                    个性化费率 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in this._enums.QrPreSetRateEnum" :key=index :command="item.id">
                            <div style="width: 100px;text-align: center">{{item.desc}}</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-button-group v-if="this.$store.state.currentHr.type!==3" style="margin-left: 10px">
                    <el-button type="warning" icon="el-icon-sold-out" @click="TerAllotSalesman" :disabled="disableBtn" style="font-size: 12px;">分配至业务员</el-button>
                    <el-button type="info" icon="el-icon-sell" @click="TerAllotSalesmanUn" :disabled="disableBtn">回收</el-button>
                </el-button-group>
                <!--
                -->
                <el-button type="danger" icon="el-icon-position" @click="TerBindRetry" :disabled="disableBtn">补绑</el-button>
                <el-button type="danger" icon="el-icon-link" @click="TerUnbind" :disabled="disableBtn">解绑</el-button>
                <el-button style="margin-left: 50px;background-color: green;color: white;font-weight: bolder" icon="el-icon-picture-outline-round" @click="Img13" round :disabled="disableBtn">合作商链接码上传</el-button>
                <el-button style="background-color: green;color: white; font-weight: bolder"  icon="el-icon-picture-outline" @click="ImgAd" round :disabled="disableBtn">合作广告大图上传</el-button>
            </div>

        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :cell-style="columnbackgroundStyle"
                    :data="devices"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="expand" label="">
                    <template slot-scope="props">
                        <div style="padding: 30px 0 30px 50px; width: 500px;">
                            <el-descriptions class="margin-top" title="" :column="1" size="mini" border>
                                <template slot="extra">
                                </template>
                                <el-descriptions-item label="商户ID">{{ props.row.inMchId }}</el-descriptions-item>
                                <el-descriptions-item label="绑定商户">{{ props.row.inMchName }}</el-descriptions-item>
                                <el-descriptions-item label="客户经理">{{ props.row.inSaleName }}</el-descriptions-item>
                                <el-descriptions-item label="当前归属">{{ props.row.inAgent.name }}</el-descriptions-item>
                                <el-descriptions-item label="仓储状态">{{ props.row.devStatStorage.desc }}</el-descriptions-item>
                                <el-descriptions-item label="设备厂商">{{ props.row.devModel.supplier }}</el-descriptions-item>
                                <el-descriptions-item label="设备型号">{{ props.row.devModel.model }}</el-descriptions-item>
                                <el-descriptions-item label="设备类别">{{ props.row.devModel.type }}</el-descriptions-item>
                                <el-descriptions-item label="终端QR">{{ props.row.payQr.qrCode }}</el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" align="center" />
                <el-table-column prop="devModel.type" label="类别" width="100" show-overflow-tooltip />
                <el-table-column prop="devModel.model" label="型号" width="100" show-overflow-tooltip />
                <el-table-column prop="terSn" label="终端SN" width="120" />
                <el-table-column prop="preSetRate" label="预设费率" width="100" align="center">
                    <template slot="header">
                        <el-tooltip effect="light" placement="top">
                            <!--
                            <div slot="content" >
                                <el-tag type="success" effect="light">
                                <span>预设费率 + D0垫资: <span class="cls-rate">0.02%</span>，单笔最低<span class="cls-rate">0.01</span>元</span>
                                </el-tag>
                                <br><br>
                                先出码给商户，商户通过扫码自行提交商户进件资料信息时，
                                <br>
                                使用到此参数，可在出码前，修改码牌的预设费率。
                                <br><br>
                                <el-tag type="info" effect="light">商户自进件</el-tag>
                                - 先出码牌，以码牌预先设定的费率为准。
                                <br><br>
                                <el-tag type="info" effect="light">先进件商户</el-tag>
                                - 后绑码牌，以进件商户设定的费率为准。
                            </div>
                            -->
                            <span style="color: green;">预设费率 <i class="el-icon-question"/></span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.devBindStat!==2" type="success" effect="light">
                            {{scope.row.preSetRate}}%
                        </el-tag>
                    </template>
                </el-table-column>
                <!--
                <el-table-column prop="devActStat" label="激活状态" width="80">
                    <template slot-scope="scope">{{_enums.DevActiveStatusEnum.getNameById(scope.row.devActStat)}}</template>
                </el-table-column>
                -->
                <el-table-column prop="devStrStat" label="仓储状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="plain" :type="scope.row.devStrStat===1?'default':'danger'">{{_enums.DevStorageStatusEnum.getNameById(scope.row.devStrStat)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="devBindStat" label="绑定状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="light" :type="scope.row.devBindStat===2?'success':'info'">{{_enums.DevBindStatusEnum.getNameById(scope.row.devBindStat)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="inMchName" label="绑定商户" width="100" show-overflow-tooltip />
                <el-table-column prop="inAgent.name" label="当前归属" width="100" show-overflow-tooltip />
                <el-table-column prop="inSaleName" label="客户经理" width="80" show-overflow-tooltip />
                <!--
                <el-table-column prop="inMchId" label="商户ID" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="channelMchNo" label="银联商户号" width="100" />
                <el-table-column prop="channelTerNo" label="银联终端号" width="80" />
                -->
                <el-table-column prop="inDateTime" width="150" label="入库时间" sortable align="center" />

                <el-table-column fixed="right" label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center" >
                            <el-button v-if="scope.row.payQr" type="text" size="mini" style="padding: 5px" @click="viewDetail(scope.row.payQr, scope.row)">下载码牌</el-button>
                        </div>
                    </template>
                </el-table-column>

            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <div class="yx-flex-v">
                <el-tag type="info" style="margin-left: 0px;">
                    <i class="header-icon el-icon-info"></i>
                    状态统计：&nbsp;&nbsp;
                    {{totalTxt}}
                </el-tag>
            </div>
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="slot, sizes, prev, pager, next, jumper, total"
                    :pager-count="5"
                    :total="total">
            </el-pagination>
        </div>

        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                width="60%"
                class="dlg-normal">
            <div style="height: 380px; margin-top: 5px; overflow-y: auto;">
                <el-form :model="DevBindForm" ref="DevBindForm">
                    <div class="form-s">

                        <el-row>
                            <el-col :span="24">
                                <div  class="yx-flex-h-start">
                                    <el-input size="small" v-model="searchValDlg.mchNameOrNo"  placeholder="输入商户名称或商户号查询 - 进件成功的商户" />
                                    <el-button type="warning" icon="el-icon-search" @click="searchDo1" style="margin-left: 5px"/>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">

                                <el-table
                                        :data="mchs"
                                        v-loading="loading2"
                                        highlight-current-row
                                        @current-change="handleCurrentChange"
                                        size="mini"
                                        height="220"
                                        style="width: 100%">
                                    <el-table-column prop="mchNo" label="商户号"></el-table-column>
                                    <el-table-column prop="mchName" label="商户名称"></el-table-column>
                                    <el-table-column prop="shortName" label="简称"></el-table-column>
                                    <el-table-column label="已绑设备数" width="100" align="center">
                                        <template slot-scope="scope">
                                            {{scope.row.devInfoList?scope.row.devInfoList.length:'-'}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column width="50">
                                        <template slot-scope="scope">
                                            <i v-if="currentRow && scope.row.id===currentRow.id" class="el-icon-circle-check"></i>
                                            <i v-else></i>
                                        </template>
                                    </el-table-column>
                                </el-table>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-pagination small
                                           @current-change="currentChange1"
                                           @size-change="sizeChange1"
                                           layout="total, prev, pager, next"
                                           :total="total1">
                            </el-pagination>

                        </el-row>
                        <el-row style="margin-top: 20px">
                            <el-col :span="24">
                                <el-form-item prop="devSnTxt">
                                    <el-input type="textarea" :rows="3" size="small" v-model="DevBindForm.devSnTxt"  :disabled="true"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                        <el-tag type="warning" style="margin-left: 10px" v-if="currentRow!==null">
                            <i class="header-icon el-icon-info"></i>
                            提示：将设备绑定【{{currentRow.mchName}}】
                        </el-tag>
                    </div>
                    <div>
                        <el-button size="small" @click="showDlg = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="dlgCommitTerBind" :disabled="currentRow === null">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>


        <el-dialog
                :title="titleDlgSale"
                :visible.sync="showDlgSale"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                width="60%"
                class="dlg-normal">
            <div style="height: 380px; margin-top: 5px; overflow-y: auto;">
                <el-form :model="DevBindForm" ref="DevBindForm">
                    <div class="form-s">

                        <el-row>
                            <el-col :span="24">
                                <div  class="yx-flex-h-start">
                                    <el-input size="small" v-model="DevBindForm.saleName"  placeholder="输入客户经理名称查询" />
                                    <el-button type="warning" icon="el-icon-search" @click="searchDo2" style="margin-left: 5px"/>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">

                                <el-table
                                        :data="salesmans"
                                        v-loading="loading2"
                                        highlight-current-row
                                        @current-change="handleCurrentChange2"
                                        size="mini"
                                        height="220"
                                        style="width: 100%">
                                    <el-table-column prop="userCode" label="客户经理代码"></el-table-column>
                                    <el-table-column prop="phone" label="客户经理手机号"></el-table-column>
                                    <el-table-column prop="name" label="客户经理姓名"></el-table-column>
                                    <el-table-column width="50">
                                        <template slot-scope="scope">
                                            <i v-if="currentRow && scope.row.id===currentRow.id" class="el-icon-circle-check"></i>
                                            <i v-else></i>
                                        </template>
                                    </el-table-column>
                                </el-table>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-pagination small
                                           @current-change="currentChange2"
                                           @size-change="sizeChange2"
                                           layout="total, prev, pager, next"
                                           :total="total2">
                            </el-pagination>
                        </el-row>
                        <el-row style="margin-top: 20px">
                            <el-col :span="24">
                                <el-form-item prop="devSnTxt">
                                    <el-input type="textarea" :rows="3" size="small" v-model="DevBindForm.devSnTxt"  :disabled="true"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                        <el-tag type="warning" style="margin-left: 10px" v-if="currentRow!==null">
                            <i class="header-icon el-icon-info"></i>
                            提示：将设备分配至【{{currentRow.name}}】
                        </el-tag>
                    </div>
                    <div>
                        <el-button size="small" @click="showDlgSale = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="dlgCommitAllotSalesman" :disabled="currentRow === null">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>

        <!--
        服务商广告上传多张广告大图
         十三号老巷上传单张太阳码图
         -->
        <el-dialog
                :title="titleDlg13"
                :visible.sync="showDlg13"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                width="60%"
                class="dlg-normal">
            <div style="height: 380px; margin-top: 5px; overflow-y: auto;" >
                <div style="text-align: center">合作商链接码</div>
                <div class="yx-flex-h-center" style="text-align: center">
                    <el-row :gutter="30">
                        <el-col :span="6">
                            <ImgUpload v-if="img1Rest" :key="curTime" v-bind:inImgUrl="devImgNew.url0" v-bind:outImgUrl.sync="devImgNew.url0"  />
                        </el-col>
                    </el-row>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                    </div>
                    <div>
                        <el-button size="small" @click="showDlg13 = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="updateImg13">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>

        <el-dialog
                :title="titleDlgAd"
                :visible.sync="showDlgAd"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                width="60%"
                class="dlg-normal">
            <div style="height: 380px; margin-top: 5px; overflow-y: auto;" >
                <el-form label-position="top">
                    <div class="form-s">

                        <el-row :gutter="30">
                            <el-col :span="6">
                                <el-form-item label="合作大屏广告图1">
                                    <ImgUpload v-if="img1Rest" :key="curTime" v-bind:inImgUrl="devImgNew.url1" v-bind:outImgUrl.sync="devImgNew.url1"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="合作大屏广告图2" >
                                    <ImgUpload v-if="img1Rest" :key="curTime" v-bind:inImgUrl="devImgNew.url2" v-bind:outImgUrl.sync="devImgNew.url2"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="合作大屏广告图3" >
                                    <ImgUpload v-if="img1Rest" :key="curTime" v-bind:inImgUrl="devImgNew.url3" v-bind:outImgUrl.sync="devImgNew.url3"  />
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                    </div>
                    <div>
                        <el-button size="small" @click="showDlgAd = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="updateImgAd">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>



        <!---->
        <el-drawer
                class="drw"
                title="终端图"
                :visible.sync="drawer"

                size = "50%"
                direction="rtl">
            <div style="margin-left: 20px">
                <el-row :gutter="30" v-if="devImg.urlObj && devImg.urlObj.url_13" style="margin-top: 30px">
                    <el-col :span="6">
                        <span class="tipTitle-collapse">合作商链接码</span>

                        <el-image placeholder="" style="width: 150px; height: 150px"
                                  :preview-src-list="[devImg.urlObj.url_13]"
                                  :src="devImg.urlObj.url_13">
                        </el-image>
                    </el-col>
                </el-row>
                <el-divider><i class="el-icon-mobile-phone"></i></el-divider>
                <el-row :gutter="30" v-if="devImg.urlObj && devImg.urlObj.ad_list" style="margin-top: 30px" >
                    <el-col :span="6" v-for="(item, index) in devImg.urlObj.ad_list" :key="index">

                        <span class="tipTitle-collapse">合作广告大图{{index+1}}</span>
                        <el-image placeholder="" style="width: 150px; height: 150px"
                                  :preview-src-list="[item.url]"
                                  :src="item.url">
                        </el-image>
                    </el-col>
                </el-row>
            </div>
        </el-drawer>



        <el-drawer
                class="drw"
                title="支付码"
                :visible.sync="drawer"
                size = "50%"
                direction="rtl">
            <QrDetailDiv :key="detailData.id" :in-detail-data="detailData" v-bind:outDrawerClose.sync="drawerRe"></QrDetailDiv>
        </el-drawer>
    </div>

</template>

<script>

    import {
        URL_DEV_MODELS
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import ImgUpload from "../../components/pub/ImgUpload";
    import QrDetailDiv from "../../components/qr/QrDetailDiv";

export default {
        name: "DevInfo",
    components: {ImgUpload, QrDetailDiv, AreaSelect},
    data() {
            return {
                curTime: (new Date()).getTime(),
                drawer: false,
                detailData:{},
                drawerRe: false,
                titleDlg13: '合作商链接码上传',
                titleDlgAd: '服务商合作广告图上传',
                titleDlg: '设备绑定商户',
                titleDlgSale: '设备分配客户经理',
                showDlg13: false,
                showDlgAd: false,
                showDlg: false,
                showDlgSale: false,
                title: '',
                disableBtn: true,
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showFV: false,
                dialogVisible: false,
                loading: false,
                loading2: false,
                loadingExt: null,
                total: 0,
                total1: 0,
                total2: 0,
                totalTxt:'',
                page: 1,
                size: 10,
                page1: 1,
                size1: 10,
                page2: 1,
                size2: 10,
                devImg:{
                },
                img1Rest: true,
                devImgNew:{
                    url0: null,
                    url1: null,
                    url2: null,
                    url3: null
                },
                devices: [],
                devModels: [],
                multipleSelection: [],
                searchValDlg: {
                    mchNameOrNo: null,
                    mchNo: null,
                    mchName: null,
                    shortName: null,
                },
                mchs:[],
                salesmans: [],
                mchCheckRow: null,
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    purDateScope: null,
                    devModelId: null,
                    devStrStatId: null,
                    devActStatId: null,
                    devBindStat: null,
                    preSetRate: null
                },
                keywordList: [
                    {id:"terSn",name:"终端SN"},
                    {id:"inMchName",name:"商户名称"}
                ],
                DevBindForm: {
                    mchName: null,
                    saleName: null,
                    devSnTxt: null,
                    mchId: null,
                    saleId: null,
                    devIds: []
                },
                currentRow: null
            }
        },
        mounted() {
            this.initDevices();
            this.getRequest(URL_DEV_MODELS).then(resp => { if (resp) this.devModels = resp.data });
        },
        methods: {
            exportData() {
                let urlParam = '/dev/devAllotOrderAll/export?page=1';
                if (this.searchVal.allotType && this.searchVal.allotType!="ALL") {
                    urlParam += '&type=' + this.searchVal.allotType;
                }
                if (this.searchVal.allotStatus && this.searchVal.allotStatus!="ALL") {
                    urlParam += '&status=' + this.searchVal.allotStatus;
                }

                this._downFile(urlParam);
            },
            // 改变Table某一列的背景颜色
            // columnIndex为列下标
            columnbackgroundStyle({ row, column, rowIndex, columnIndex }) {
                if (column.label == '操作') {
                    //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                    return 'background:#fafafa;'
                }
            },
            openLoading() {
                setTimeout(() => {
                    //this.loadingExt.close();
                }, 9000);
            },
            handleCurrentChange(val) {
                this.currentRow = val;
                this.DevBindForm.mchId = val.id;
            },
            handleCurrentChange2(val) {
                this.currentRow = val;
                this.DevBindForm.saleId = val.id;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initDevices();
            },
            searchDo1() {
                this.page1 = 1;
                this.initMchs();
            },
            searchDo2() {
                this.page2 = 1;
                this.initSalesmans();
            },
            initMchs() {
                this.currentRow = null;
                this.loading2 = true;
                let channelStatusCodes = [1] // 仅已审核通过的支持绑定
                let url = '/mch/mchInfo?page=' + this.page1 + '&size=' + this.size1 + '&queryBase=1' + '&status=1' + '&channelStatusCodes=' + channelStatusCodes;
                if(this.searchValDlg.mchNameOrNo) {
                    url += '&mchNameOrNo=' + this.searchValDlg.mchNameOrNo;
                }
                this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp) {
                        this.mchs = resp.data;
                        this.total1 = resp.total;
                        //this.total = Number(resp.total);
                        //this.total = resp.total;

                    }
                })
            },
            initSalesmans() {
                this.currentRow = null;
                this.loading2 = true;
                let url = '/sal/salInfoAll?page='  + this.page2 + '&size=' + this.size2;
                if(this.DevBindForm.saleName) {
                    url += '&saleName=' + this.DevBindForm.saleName;
                }
                this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp) {
                        this.salesmans = resp.data;
                        this.total2 = resp.total;
                    }
                })
            },
            initDevices() {
                this.loading = true;
                let urlParam = '?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.devModelId) {
                    urlParam += '&modelId=' + this.searchVal.devModelId;
                }
                if (this.searchVal.devStrStatId) {
                    urlParam += '&devStrStat=' + this.searchVal.devStrStatId;
                }
                if (this.searchVal.devActStatId) {
                    urlParam += '&devActStat=' + this.searchVal.devActStatId;
                }
                if (this.searchVal.devBindStat) {
                    urlParam += '&devBindStat=' + this.searchVal.devBindStat;
                }
                if(this.searchVal.devFpStat) {
                    urlParam += '&devFpStat='  + this.searchVal.devFpStat;
                }
                if(this.searchVal.preSetRate) {
                    urlParam += '&preSetRate='  + this.searchVal.preSetRate;
                }
                if (this.searchVal.purDateScope) {
                    urlParam += '&purDateScope=' + this.searchVal.purDateScope;
                }

                this.getRequest("/dev/devInfo" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devices = resp.data;
                        this.total = resp.total;

                        this.devices.forEach((item,index)=>{
                           if(item.remark) {
                               this.devices[index].urlObj = JSON.parse(item.remark);
                           }
                           else {
                               this.devices[index].urlObj = null;
                           }
                        });

                    }
                });

                this.totalTxt = '';
                this.getRequest("/dev/devInfoStatActTotal" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        let ar = resp.data;
                        this.totalTxt = ar[0];
                    }
                });

            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initDevices();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initDevices();
            },
            sizeChange1(currentSize) {
                this.size1 = currentSize;
                this.initMchs();
            },
            currentChange1(currentPage) {
                this.page1 = currentPage;
                this.initMchs();
            },
            sizeChange2(currentSize) {
                this.size2 = currentSize;
                this.initSalesmans();
            },
            currentChange2(currentPage) {
                this.page2 = currentPage;
                this.initSalesmans();
            },
            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            viewDetail(data, dev) {
                Object.assign(this.detailData, data);
                this.detailData.mchName = dev.inMchName
                this.drawer = true;
            },
            Img13() {
                this.curTime = (new Date()).getTime();
                this.devImgNew.url0 = null;

                this.showDlg13 = true;
            },
            ImgAd() {
                this.curTime = (new Date()).getTime();
                this.devImgNew.url1 = null;
                this.devImgNew.url2 = null;
                this.devImgNew.url3 = null;
                this.showDlgAd = true;
            },
            TerBindRetry() {
                this.DevBindForm.devIds = [];
                this.multipleSelection.forEach( item => {
                    if(item.devBindStat === this._enums.DevBindStatusEnum.绑定中.id ) {
                        this.DevBindForm.devIds.push(item.id);
                    }
                });

                if(this.DevBindForm.devIds.length===0) {
                    this.$message.error("没有需要补绑的设备 !");
                    return;
                }

                this.$confirm( '补绑设备 ' + this.DevBindForm.devIds.length + ' 台' , '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.putRequest("/dev/devBindRetry" + "?devIds=" + this.DevBindForm.devIds).then(resp => {
                        if (resp) {
                            this.initDevices();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            TerUnbind() {
                this.DevBindForm.devIds = [];
                this.multipleSelection.forEach( item => {
                    if(item.devBindStat === this._enums.DevBindStatusEnum.已绑定.id ) {
                        this.DevBindForm.devIds.push(item.id);
                    }
                });

                if(this.DevBindForm.devIds.length===0) {
                    this.$message.error("没有需要解绑的设备 !");
                    return;
                }

                this.$confirm( '解绑设备 ' + this.DevBindForm.devIds.length + ' 台' , '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //this.loadingExt = this.$loading({ lock: true, background: 'rgba(255, 255, 255, 0.7)', target: document.querySelector('.yx-div')});
                    this.putRequest("/dev/devUnBind" + "?devIds=" + this.DevBindForm.devIds).then(resp => {
                        if (resp) {
                            this.initDevices();
                        }
                        //this.loadingExt.close();
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            updateImg13() {
                this.showDlg13 = false;
                let url_list = [];
                if(this.devImgNew.url0) url_list.push(this.devImgNew.url0);
                //if(url_list.length>0)
                {
                    this.updateImg('U13', url_list);
                }

            },
            updateImgAd() {
                this.showDlgAd = false;
                let url_list = [];
                if(this.devImgNew.url1) url_list.push(this.devImgNew.url1);
                if(this.devImgNew.url2) url_list.push(this.devImgNew.url2);
                if(this.devImgNew.url3) url_list.push(this.devImgNew.url3);
                //if(url_list.length>0)
                {
                    this.updateImg('UAD', url_list);
                }
            },
            updateImg(type, url_list) {
                this.DevBindForm.devIds = [];
                this.multipleSelection.forEach( item => {
                    this.DevBindForm.devIds.push(item.id);
                });

                if(this.DevBindForm.devIds.length===0) {
                    this.$message.error("没有勾选需要更新图片的设备 !");
                    return;
                }

                this.putRequest("/dev/devImg" + "?type=" + type + "&url_list=" + url_list + "&devIds=" + this.DevBindForm.devIds).then(resp => {
                    this.initDevices();
                });
            },
            dlgCommitTerBind() {
                if(this.DevBindForm.mchId===null) {
                    this.$message.error("未选择商户 !");
                    return;
                }
                if(this.DevBindForm.devIds.length===0) {
                    this.$message.error("未选择设备 !");
                    return;
                }
                this.loading2 = true;
                // this.putRequest("/dev/devBind" + "?storeId=7134845665842036737" + "&devIds=" + this.DevBindForm.devIds).then(resp => {
                    this.putRequest("/dev/devBind" + "?mchId=" + this.DevBindForm.mchId + "&devIds=" + this.DevBindForm.devIds).then(resp => {
                    this.loading2 = false;
                    this.showDlg = false;
                    this.initDevices();
                });
            },
            dlgCommitAllotSalesman() {
                if(this.DevBindForm.saleId===null) {
                    this.$message.error("未选择客户经理 !");
                    return;
                }
                if(this.DevBindForm.devIds.length===0) {
                    this.$message.error("未选择设备 !");
                    return;
                }
                this.loading2 = true;
                this.putRequest("/dev/devAllotSalesman" + "?saleId=" + this.DevBindForm.saleId + "&devIds=" + this.DevBindForm.devIds).then(resp => {
                    this.loading2 = false;
                    this.showDlgSale = false;
                    this.initDevices();
                });
            },
            TerBind() {
                this.mchs=[];
                this.currentRow = null;
                this.DevBindForm.mchName='';
                this.DevBindForm.devSnTxt='';
                this.DevBindForm.mchId = null;
                this.DevBindForm.devIds = [];
                try {
                    this.multipleSelection.forEach( item => {
                        if(item.devStrStat !== this._enums.DevStorageStatusEnum.在库.id ) {
                            throw ("设备未在库中 ! 序列号：" + item.terSn);
                        }
                        if(item.devBindStat !== this._enums.DevBindStatusEnum.未绑定.id ) {
                            throw ("设备已被绑定 ! 序列号：" + item.terSn);
                        }
                        if(item.inSaleId && this.$store.state.currentHr.type!==3) {
                            throw ("设备已分配客户经理，请先回收 ! 序列号：" + item.terSn);
                        }

                        this.DevBindForm.devSnTxt += '【' + item.devModel.model + '：' + item.terSn + '】\n';
                        this.DevBindForm.devIds.push(item.id);
                    });
                }
                catch (e) {
                    this.$message.error(e);
                    return;
                }
                this.total1 = 0;
                this.showDlg = true;
            },
            TerSetRate(command) {
                let rate = this._enums.QrPreSetRateEnum.getNameById(command);
                let desc = this._enums.QrPreSetRateEnum.getDescById(command);
                let ids = [];
                try {
                    this.multipleSelection.forEach( item => {
                        if(item.devStrStat !== this._enums.DevStorageStatusEnum.在库.id ) {
                            throw ("设备未在库中 ! 序列号：" + item.terSn);
                        }
                        if(item.devBindStat !== this._enums.DevBindStatusEnum.未绑定.id ) {
                            throw ("设备已被绑定 ! 序列号：" + item.terSn);
                        }
                        if(item.inSaleId && this.$store.state.currentHr.type!==3) {
                            throw ("设备已分配客户经理，请先回收 ! 序列号：" + item.terSn);
                        }
                        ids.push(item.id);
                    });
                    this.$confirm('对选中的【' + this.multipleSelection.length + '】个码牌重设费率为【' + desc + '】？',
                        '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                        this.loading = true;
                        this.putRequest("/dev/devSetRate" + "?preSetRate=" + rate + "&devIds=" + ids).then(resp => {
                            if (resp) {
                                this.loading = false;
                                this.initDevices();
                            }
                        });
                    }).catch(() => {
                        this.$message({ type: 'info', message: '已取消' });
                    });
                }
                catch (e) {
                    this.$message.error(e);
                    return;
                }
            },
            TerAllotSalesmanUn() {
                let terSns = "";
                this.DevBindForm.saleId = "0";
                this.DevBindForm.devIds = [];
                try {
                    this.multipleSelection.forEach( item => {
                        if(!item.inSaleId) {
                            throw ("设备未分配 ! 序列号：" + item.terSn);
                        }
                        if(item.devStrStat !== this._enums.DevStorageStatusEnum.在库.id ) {
                            throw ("设备未在库中 ! 序列号：" + item.terSn);
                        }
                        if(item.devBindStat !== this._enums.DevBindStatusEnum.未绑定.id ) {
                            throw ("设备已被绑定 ! 序列号：" + item.terSn);
                        }

                        this.DevBindForm.devIds.push(item.id);
                        terSns += item.terSn + '，';
                    });

                    terSns = terSns.substring(0, terSns.length-1);
                    this.$confirm('设备回收【' + terSns + '】取消分配？',
                        '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                        this.loading = true;
                        this.putRequest("/dev/devAllotSalesman?devIds=" + this.DevBindForm.devIds).then(resp => {
                            this.loading = false;
                            this.initDevices();
                        });
                    }).catch(() => {
                        this.$message({ type: 'info', message: '已取消' });
                    });
                }
                catch (e) {
                    this.$message.error(e);
                }
            },
            TerAllotSalesman() {
                this.salesmans=[];
                this.currentRow = null;
                this.DevBindForm.saleName='';
                this.DevBindForm.devSnTxt='';
                this.DevBindForm.mchId = null;
                this.DevBindForm.devIds = [];
                try {
                    this.multipleSelection.forEach( item => {
                        if(item.devStrStat !== this._enums.DevStorageStatusEnum.在库.id ) {
                            throw ("设备未在库中 ! 序列号：" + item.terSn);
                        }
                        if(item.devBindStat !== this._enums.DevBindStatusEnum.未绑定.id ) {
                            throw ("设备已被绑定 ! 序列号：" + item.terSn);
                        }
                        if(item.inSaleId && this.$store.state.currentHr.type!==3) {
                            throw ("设备已分配客户经理，请先回收 ! 序列号：" + item.terSn);
                        }

                        this.DevBindForm.devSnTxt += '【' + item.devModel.model + '：' + item.terSn + '】\n';
                        this.DevBindForm.devIds.push(item.id);
                    });
                }
                catch (e) {
                    this.$message.error(e);
                    return;
                }
                this.total2 = 0;
                this.showDlgSale = true;
            }
        }

    }
</script>

<style scoped>

</style>
